import { AppLanguage } from '~/types/locale'

export interface NotificationResponse {
  success: boolean
  data?: NotificationData[]
  meta: {
    currentPage: number
    totalPages: number
    pageSize: number
    totalCount: number
    newCount: number
  }
}

export interface NotificationData {
  id: number
  message: NotificationMessage
  isRead: boolean
  isNew: boolean
  createdAt: string
}

type SystemMessages = {
  [values in AppLanguage]: SystemMessage
}

export interface NotificationMessage extends SystemMessages {
  title: NotificationType
  item_name: string
  league?: string
  total_users?: number
  new_league?: number
  previous_league?: number
  rank?: number
  rewards?: { gems?: number; xp?: number; kudos?: number }
  week?: number
  xp?: number
  gems?: number
  subject?: string
  category?: string
  image_path?: string
}

export interface SystemMessage {
  body: string
  buttonText?: string
  link: string
  srcKey: string
  title: string
}

export const enum ChecklistName {
  CHECKLIST = 'checklist',
  ONBOARDING = 'onboarding',
}

export const enum NotificationType {
  LEADERBOARD_JOIN = 'leaderboard_join',
  LEADERBOARD_SEASON_END_RESULT = 'leaderboard_season_end_result',
  LEADERBOARD_LAST_WEEK_RESULT = 'leaderboard_last_week_result',
  CHECKLIST = 'checklist_item_completed',
  BADGE_UNLOCKED = 'badge_unlocked',
  FRIENDS_FAMILY_DISCOUNT = 'subscription_discount',
  TEACHER_ACCESS = 'teacher_access',
  SYSTEM_NOTIFICATION = 'system_notification',
}
